/**
 * 积分模板系统 API 服务
 */
import api from './api';

const pointsTemplatesAPI = {
  // ========== 积分项目池 API ==========
  
  /**
   * 获取积分项目池列表
   * @param {Object} params - 查询参数
   * @param {string} params.item_type - 类型：add|deduct
   * @param {string} params.category - 分类
   * @param {string} params.school_stage - 学段：小学|初中|高中
   * @param {string} params.frequency - 频率：high|medium|low
   * @param {string} params.keyword - 搜索关键词
   */
  getItemPool: (params = {}) => {
    return api.get('/points-templates/pool', { params });
  },

  /**
   * 获取积分项目分类列表
   * @param {string} item_type - 类型：add|deduct
   */
  getCategories: (item_type) => {
    return api.get('/points-templates/pool/categories', {
      params: { item_type }
    });
  },

  /**
   * 获取推荐的高频项目
   * @param {string} school_stage - 学段
   * @param {number} limit - 数量限制
   */
  getRecommended: (school_stage, limit = 20) => {
    return api.get('/points-templates/pool/recommended', {
      params: { school_stage, limit }
    });
  },

  // ========== 用户模板管理 API ==========

  /**
   * 获取系统推荐模板
   */
  getSystemTemplates: () => {
    return api.get('/points-templates/system-templates');
  },

  /**
   * 获取系统模板详情
   * @param {number} templateId - 模板ID
   */
  getSystemTemplateDetail: (templateId) => {
    return api.get(`/points-templates/system-templates/${templateId}`);
  },

  /**
   * 获取教师的模板列表
   */
  getMyTemplates: () => {
    return api.get('/points-templates/my-templates');
  },

  /**
   * 创建用户模板
   * @param {Object} data - 模板数据
   * @param {string} data.template_name - 模板名称
   * @param {number} data.based_on_system_template_id - 基于的系统模板ID
   * @param {string} data.school_stage - 学段
   * @param {Array} data.selected_items - 选中的项目ID列表
   * @param {boolean} data.is_default - 是否设为默认
   */
  createTemplate: (data) => {
    return api.post('/points-templates/my-templates', data);
  },

  /**
   * 获取模板详情
   * @param {number} templateId - 模板ID
   */
  getTemplateDetail: (templateId) => {
    return api.get(`/points-templates/my-templates/${templateId}`);
  },

  /**
   * 更新模板基本信息
   * @param {number} templateId - 模板ID
   * @param {Object} data - 更新数据
   */
  updateTemplate: (templateId, data) => {
    return api.put(`/points-templates/my-templates/${templateId}`, data);
  },

  /**
   * 删除模板
   * @param {number} templateId - 模板ID
   */
  deleteTemplate: (templateId) => {
    return api.delete(`/points-templates/my-templates/${templateId}`);
  },

  /**
   * 向模板添加项目
   * @param {Object} data - 项目数据
   */
  addItemToTemplate: (data) => {
    return api.post(`/points-templates/my-templates/${data.template_id}/items`, data);
  },

  /**
   * 从模板移除项目
   * @param {number} templateId - 模板ID
   * @param {number} itemId - 项目ID
   */
  removeItemFromTemplate: (templateId, itemId) => {
    return api.delete(`/points-templates/my-templates/${templateId}/items/${itemId}`);
  },

  /**
   * 向模板添加项目（从项目池）
   * @param {number} templateId - 模板ID
   * @param {Array} pool_item_ids - 项目池ID列表
   */
  addItemsToTemplate: (templateId, pool_item_ids) => {
    return api.post(`/points-templates/my-templates/${templateId}/items`, {
      pool_item_ids
    });
  },

  /**
   * 添加自定义项目
   * @param {number} templateId - 模板ID
   * @param {Object} data - 项目数据
   */
  addCustomItem: (templateId, data) => {
    return api.post(`/points-templates/my-templates/${templateId}/custom-items`, data);
  },

  /**
   * 更新模板项目
   * @param {number} itemId - 项目ID
   * @param {Object} data - 更新数据
   */
  updateTemplateItem: (itemId, data) => {
    return api.put(`/points-templates/items/${itemId}`, data);
  },

  /**
   * 更新模板项目
   * @param {number} itemId - 项目ID
   * @param {Object} data - 更新数据
   */
  updateItem: (itemId, data) => {
    return api.put(`/points-templates/items/${itemId}`, data);
  },

  /**
   * 删除模板项目
   * @param {number} itemId - 项目ID
   */
  deleteItem: (itemId) => {
    return api.delete(`/points-templates/items/${itemId}`);
  },

  /**
   * 记录项目使用统计
   * @param {Object} data
   * @param {number} data.pool_item_id - 项目池ID
   * @param {number} data.user_template_item_id - 用户模板项目ID
   */
  recordUsage: (data) => {
    return api.post('/points-templates/usage', data);
  },

  /**
   * 获取常用项目
   * @param {number} limit - 数量限制
   */
  getFrequentlyUsed: (limit = 10) => {
    return api.get('/points-templates/frequently-used', {
      params: { limit }
    });
  }
};

export default pointsTemplatesAPI;

